/**
 * Learn Library — annual subscription, browser access to paid minimanuals (downloads not included).
 * Includes the flagship **Create Cryptocurrency** module for subscribers.
 */
export const LEARN_SUBSCRIPTION_HIGHLIGHT_SLUG = 'create-cryptocurrency'

/** Marketing label for the module highlighted in subscription copy. */
export const LEARN_SUBSCRIPTION_HIGHLIGHT_TITLE = 'Create Cryptocurrency'

/** Display price (GBP/year). Must match Netlify `LEARN_SUBSCRIPTION_UNIT_AMOUNT_PENCE` (e.g. 9900) if you use inline checkout. */
export const LEARN_SUBSCRIPTION_PRICE_GBP_YEAR = 99

/**
 * Direct Stripe checkout URL (e.g. subscription Payment Link from Dashboard: https://buy.stripe.com/...).
 * Set in Netlify as `VITE_LEARN_LIBRARY_CHECKOUT_URL` and rebuild. When set, /subscribe sends users here
 * instead of calling create-learn-subscription-checkout (no STRIPE_LEARN_SUBSCRIPTION_PRICE_ID needed for that flow).
 */
export const LEARN_SUBSCRIPTION_CHECKOUT_URL: string =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_LEARN_LIBRARY_CHECKOUT_URL) || ''

export const LEARN_SUBSCRIPTION_TAGLINE =
  'Full minimanual library for one year in your browser — including the in-depth Create Cryptocurrency minimanual. PDF/HTML downloads are not included with the subscription.'

/**
 * One-time purchase of the **entire** minimanual library (single Checkout line item, not per module).
 * Align Stripe Product/Price with this (e.g. unit_amount 19999 pence, GBP). Purchase confirmation emails reference £199.99 as list price; charged amount always comes from Stripe.
 */
export const LEARN_LIBRARY_ONE_TIME_GBP = 199.99

/**
 * Stripe **Payment Link** for one-time full-library checkout (create in Dashboard — no Netlify checkout function).
 * Netlify: `VITE_LEARN_LIBRARY_ONE_TIME_PAYMENT_URL` — rebuild after changing.
 */
export const LEARN_LIBRARY_ONE_TIME_PAYMENT_URL: string =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_LEARN_LIBRARY_ONE_TIME_PAYMENT_URL) || ''

/**
 * Tyl by NatWest **Pay by Link** for the same one-time full-library purchase (optional alternative to Stripe).
 * Set in Netlify as `VITE_LEARN_LIBRARY_ONE_TIME_TYL_PAYMENT_URL` — rebuild after changing.
 * When both this and Stripe are set, /subscribe shows both options; entitlement still depends on backend/process you use for Tyl.
 */
export const LEARN_LIBRARY_ONE_TIME_TYL_PAYMENT_URL: string =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_LEARN_LIBRARY_ONE_TIME_TYL_PAYMENT_URL) || ''
